// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MLji","colBig":"styles_colBig__b2qQV","colSmall":"styles_colSmall__3wKKu"};